export default __webpack_public_path__ + "static/media/fMaltoBuza15.e7dc2958.png";